import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PageLayout from '../../components/PageLayout';
import { supabase } from '../../supabaseClient';
import { Box, Typography } from '@mui/joy';

function ClientPermitDetail() {
  const { id } = useParams();
  const [permit, setPermit] = useState(null);
  const [comments, setComments] = useState([]);

  useEffect(() => {
    async function fetchPermit() {
      const { data, error } = await supabase
        .from('project_records')
        .select('*, permit_documents(*)')
        .eq('id', id)
        .single();
      if (error) {
        console.error('Failed to fetch permit:', error);
      } else {
        setPermit({
          ...data,
          files: data.permit_documents || []
        });
      }
    }

    async function fetchComments() {
      const { data, error } = await supabase
        .from('permit_comments')
        .select('*, users(display_name)')
        .eq('permit_id', id)
        .order('created_at', { ascending: false });
      if (error) {
        console.error('Failed to fetch comments:', error);
      } else {
        setComments(data);
      }
    }

    fetchPermit();
    fetchComments();
  }, [id]);

  if (!permit) {
    return <div>Loading...</div>;
  }

  return (
    <PageLayout title="Permit Details">
      <Box sx={{ px: 3, py: 4, maxWidth: 1000, mx: 'auto' }}>
        <Typography level="h4" sx={{ mt: 3, mb: 1 }}>
          General Information
        </Typography>
        <Typography>
          <strong>Permit Number:</strong> {permit.permit_number}
        </Typography>
        <Typography>
          <strong>Record Type:</strong> {permit.record_type}
        </Typography>
        <Typography>
          <strong>Status:</strong> {permit.status}
        </Typography>
        <Typography>
          <strong>Applicant:</strong> {permit.applicant}
        </Typography>

        <Typography level="h4" sx={{ mt: 3, mb: 1 }}>
          Dates
        </Typography>
        <Typography>
          <strong>Issued Date:</strong> {permit.issued_date}
        </Typography>
        <Typography>
          <strong>Approval Date:</strong> {permit.issue_date}
        </Typography>
        <Typography>
          <strong>Expiration Date:</strong> {permit.expiration_date}
        </Typography>

        <Typography level="h4" sx={{ mt: 3, mb: 1 }}>
          Notes
        </Typography>
        <Typography>
          {permit.notes}
        </Typography>

        {permit.record_type === 'Bond' && (
          <>
            <Typography level="h4" sx={{ mt: 3, mb: 1 }}>
              Bond Details
            </Typography>
            <Typography>
              <strong>Bond Amount:</strong> {permit.bond_amount}
            </Typography>
            <Typography>
              <strong>Bond Expiration:</strong> {permit.bond_expiration}
            </Typography>
          </>
        )}

        <Typography level="h4" sx={{ mt: 3, mb: 1 }}>
          Comments
        </Typography>
        <ul>
          {comments.map(comment => (
            <li key={comment.id}>
              <Typography>
                <strong>{comment.users?.display_name || comment.author}</strong> ({comment.created_at}):
              </Typography>
              <Typography>
                {comment.text}
              </Typography>
            </li>
          ))}
        </ul>

        <Typography level="h4" sx={{ mt: 3, mb: 1 }}>
          Permit Files
        </Typography>
        <ul>
          {permit.files && permit.files.length > 0 ? (
            permit.files.map(file => (
              <li key={file.id}>
                <a href={file.url} target="_blank" rel="noopener noreferrer">{file.name}</a>
              </li>
            ))
          ) : (
            <Typography>No files available.</Typography>
          )}
        </ul>
      </Box>
    </PageLayout>
  );
}

export default ClientPermitDetail;
